import { Params, BuildersOverride, FilterBuilder } from './Types';

import dateFromTSBuilder from './builders/dateFromTSBuilder';
import dateToTSBuilder from './builders/dateToTSBuilder';
import minimumStayMonthsBuilder from './builders/minimumStayMonthsBuilder';
import kindAndTypeBuilder from './builders/kindAndTypeBuilder';
import furnitureBuilder from './builders/furnitureBuilder';
import billsBuilder from './builders/billsBuilder';
import registrationBuilder from './builders/registrationBuilder';
import rulesBuilder from './builders/rulesBuilder';
import genderBuilder from './builders/genderBuilder';
import suitableForBuilder from './builders/suitableForBuilder';
import creationDateTSBuilder from './builders/creationDateTSBuilder';
import roomsBuilder from './builders/roomsBuilder';
import priceEURBuilder from './builders/priceEURBuilder';
import isSearchableBuilder from './builders/isSearchableBuilder';
import advertiserBuilder from './builders/advertiserBuilder';
import countryBuilder from './builders/countryBuilder';
import cityBuilder from './builders/cityBuilder';

const defaultBuilders: BuildersOverride = {
  dateFromTS: dateFromTSBuilder,
  dateToTS: dateToTSBuilder,
  minimumStayMonths: minimumStayMonthsBuilder,
  kindAndType: kindAndTypeBuilder,
  furniture: furnitureBuilder,
  bills: billsBuilder,
  registration: registrationBuilder,
  rules: rulesBuilder,
  gender: genderBuilder,
  suitableFor: suitableForBuilder,
  creationDateTS: creationDateTSBuilder,
  rooms: roomsBuilder,
  priceEUR: priceEURBuilder,
  isSearchable: isSearchableBuilder,
  advertiser: advertiserBuilder,
  country: countryBuilder,
  city: cityBuilder,
};

export default (builders: BuildersOverride = {}): FilterBuilder => {
  return (params: Params) => {
    const buildersSet = { ...defaultBuilders, ...builders };

    const filterParts: string[] = Object.keys(buildersSet).map(key =>
      buildersSet[key](params),
    );

    return filterParts.filter(Boolean).join(' AND ');
  };
};
